<script>
  import { _ as t } from "svelte-i18n";

  import Timeline from "./TimelineItem.svelte";

  export let item;
</script>

<Timeline {item}>
  <div class="description">{$t("timeline.caseOpening")}</div>
  <p class="description">{item.description ? item.description : ""}</p>
</Timeline>

<style>
  .description {
    margin-top: 8px;
    color: #999;
    font-size: 13px;
  }
</style>
